import { useMemo, useContext, useEffect } from "react";

import { AppContexts } from "../../providers";


const UnitInfo = ({ reservation }) => {
  const { rental, getRental } = useContext(AppContexts.RentalsContext);
  const { settings, get } = useContext(AppContexts.SettingsContext);

  useEffect(() => {
    get(["custom_macros"]);
  }, []);

  useEffect(() => {
    if (reservation && reservation.rental_id) {
      getRental(reservation.rental_id);
    }
  }, [reservation]);

  const customMacrosValues = useMemo(() => {
    const rentalMacros = rental.custom_macro_values || [];
    const customMacros = settings.custom_macros || [];
    return customMacros.map((cmacro) => {
      const foundMacro = rentalMacros.find((macro) => cmacro.id === macro.macro_id);
      if (foundMacro) {
        return {
          ...cmacro,
          content: foundMacro.content,
        };
      } else {
        return cmacro;
      }
    });
  }, [settings.custom_macros, rental.custom_macro_values]);

  return (
    <div
      id="unit-info-modal"
      className="uk-modal-full hms-modals uk-modal uk-open"
      uk-offcanvas="flip: true; overlay: true"
    >
      <div className="uk-offcanvas-bar">
        <div className="hms-modals-main">
          <button
            className="uk-offcanvas-close uk-close-large"
            type="button"
            uk-close="true"
          />
          <div className="uk-modal-header">
            <h2 className="uk-modal-title">
              Property Macros
            </h2>
          </div>
          <div className="uk-modal-body uk-margin">
            <ul
              uk-accordion="multiple: true"
              className="scheduler-advanced-options"
            >
              {
                customMacrosValues?.map((macro, index) => {
                  return (
                    <li key={index}>
                      <div className="uk-accordion-title" href>
                        {macro.macro}
                      </div>
                      <div className="uk-accordion-content">
                        {macro.content || ""}
                      </div>
                    </li>
                  );
                })
              }
            </ul>
          </div>
        </div>
      </div>
    </div>    
  );
};

export default UnitInfo;
